module.exports = __webpack_public_path__ + "static/img/pLogo.e5df6bb9.png";